'use client'
import InteractivePapersList from '@/components/page-partials/student/interactive-papers/InteractivePapersList'
import { useEffect, useState } from 'react'
import { v4 as uuidv4 } from 'uuid'

const Page = () => {
  const [anonymousUserId, setAnonymousUserId] = useState<string | null>(null)

  // Get or create anonymous user ID on component mount
  useEffect(() => {
    const getOrCreateAnonymousUserId = () => {
      // Try to get existing ID from localStorage
      let anonymousUserId = localStorage.getItem('anonymousUserId')

      // If no ID exists, create a new one
      if (!anonymousUserId) {
        anonymousUserId = uuidv4()
        localStorage.setItem('anonymousUserId', anonymousUserId)
      }

      setAnonymousUserId(anonymousUserId)
    }

    getOrCreateAnonymousUserId()
  }, [])

  if (!anonymousUserId) {
    return <></>
  }

  return <InteractivePapersList anonymousUserId={anonymousUserId} />
}

export default Page
